import "../constants/invoiceFontFaces";
import type { InvoiceCustomStyle } from "../types/invoiceCustomStyle.types";

export const createInvoiceStyleTokens = (style: InvoiceCustomStyle) => {
  const border = style.borders.width > 0 ? `${style.borders.width}px ${style.borders.style} ${style.borders.color}` : "none";
  const divider = `1px ${style.borders.style} ${style.colors.border}`;
  const radius = Math.max(0, style.borders.radius);

  return {
    colors: {
      title: style.colors.title,
      subTitle: style.colors.subTitle,
      pageBackground: style.colors.pageBackground,
      cardBackground: style.colors.cardBackground,
      body: style.colors.body,
      border: style.colors.border,
      total: style.colors.total,
      icon: style.colors.icon,
    },

    typography: {
      bodyFontFamily: `"${style.typography.fontFamily}", "Roboto", "Helvetica", "Arial", sans-serif`,
      headingFontFamily: `"${style.typography.headingFontFamily}", "Roboto", "Helvetica", "Arial", sans-serif`,
    },

    borders: {
      value: border,
      color: style.borders.color,
      width: style.borders.width,
      style: style.borders.style,
      divider,
      radius: {
        small: `${radius * 0.5}px`,
        medium: `${radius * 0.75}px`,
        large: `${radius}px`,
      },
    },

    spacing: {
      cardGap: `${Math.max(0, style.spacing.cardGap)}px`,
    },

    icons: style.icons,

    shadow: "0px 4px 20px rgba(0, 0, 0, 0.03)",
  };
};

export type InvoiceStyleTokens = ReturnType<typeof createInvoiceStyleTokens>;
